// src/components/Impressum.tsx
import React from "react";

const Impressum: React.FC = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-16">
      <h1 className="text-3xl font-bold mb-8">Impressum</h1>

      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-bold mb-2">Angaben gemäß § 5 TMG</h2>
          <p className="text-gray-600">
            ApplicationFlow GmbH
            <br />
            Sandwingert 4
            <br />
            69123 Heidelberg
            <br />
            Deutschland
          </p>
        </div>

        <div>
          <h2 className="text-xl font-bold mb-2">Kontakt</h2>
          <p className="text-gray-600">E-Mail: info@applicationflow.de</p>
        </div>

        <div>
          <h2 className="text-xl font-bold mb-2">Handelsregister</h2>
          <p className="text-gray-600">
            Registergericht: Amtsgericht Heidelberg
            <br />
            Registernummer: HRB 123456
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
